export default "/assets/images/app-update-img-04.webp?7095fe9598a87e47eb7fad9638b210f5";